function _template() {return `<div class="modal-wrapper">
    <div class="modal">
    </div>
</div>
`;}export default function (ctx) {return _template.call(ctx, ctx);};